<script setup>
import { onMounted } from 'vue';
import { useModalContext } from './useModal';

const { hasModalFooter } = useModalContext();

onMounted(() => {
  hasModalFooter.value = true;
});
</script>

<template>
  <div
    data-component="CsModalFooter"
    class="sticky bottom-0 flex gap-2 justify-end p-4 border-t border-brand-gray-8 dark:border-brand-gray-15 bg-brand-background h-[60px]"
  >
    <slot />
  </div>
</template>
